import { createSlice } from "@reduxjs/toolkit";

const languageReducer = createSlice({
  name: "languageReducer",
  initialState: {
    Language: localStorage.getItem("lang") || "ar",
  },
  reducers: {
    setLanguage: (state, action) => {
      state.Language = action.payload;
      localStorage.setItem("lang", action.payload); 
    },
  },
});

export const { setLanguage } = languageReducer.actions;
export default languageReducer.reducer;
